const SendFundsSvg = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.8838 2.75L4.35156 12.8333H10.9974L10.111 19.25L17.6432 9.16667H10.9974L11.8838 2.75Z"
      fill="#F8AD21"
    />
  </svg>
);
export default SendFundsSvg;
